import { useState } from 'react';
import { UserData } from '../../types';
import { fetchUsers } from '../../apiServices';

const useUserData = () => {
  const [users, setUsers] = useState<UserData[]>([]);
  const [loading, setLoading] = useState(true);

  const fetchData = async (): Promise<UserData[]> => {
    setLoading(true);
    try {
      const data = await fetchUsers();
      setUsers(data);
      return data;
    } catch (error) {
      setUsers([]);
      return [];
    } finally {
      setLoading(false);
    }
  };

  return {
    users,
    userCount: users.length,
    loading,
    refetch: fetchData,
  };
};

export default useUserData;
